/*
 *
 * PayToCardPopup
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 02-Oct-2026
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  confirm: <PortalMessage id='t.app.project.btn.confirm' defaultMessage='Confirm' />,
  titleManage: <PortalMessage id='t.app.terminalsManagement.vasConfiguration.popup.title' defaultMessage='Manage the service' />,
  serviceName: <PortalMessage id='t.app.terminalsManagement.vasConfiguration.title.PayToCard' defaultMessage='Pay-to-card' />
}

export const captions = defineMessages({
  status: { id: 't.app.terminalsManagement.vasConfiguration.status', defaultMessage: 'Status' },
  statusLabel_Enabled: { id: 't.app.terminalsManagement.vasConfiguration.status.enabled', defaultMessage: 'Enabled' },
  statusLabel_Disabled: { id: 't.app.terminalsManagement.vasConfiguration.status.disabled', defaultMessage: 'Disabled' },
  close: { id: 't.app.project.btn.close', defaultMessage: 'Close' },
  back: { id: 't.app.project.btn.back', defaultMessage: 'Back' },
  payToCardIban: { id: 't.app.terminalsManagement.vasConfiguration.payToCard.iban', defaultMessage: 'IBAN' },
  payToCardIbanDescription: {
    id: 't.app.terminalsManagement.vasConfiguration.payToCard.ibanDescription',
    defaultMessage: 'Bank account used for the Pay-to-card service'
  },
  payToCardVerificationTitle: {
    id: 't.app.terminalsManagement.vasConfiguration.payToCard.verificationTitle',
    defaultMessage: 'Cardholder name verification'
  },
  payToCardVerificationDescription: {
    id: 't.app.terminalsManagement.vasConfiguration.payToCard.verificationDescription',
    defaultMessage: "To credit the payment, the cardholder's name is checked against the name entered on the card. Choose the required match level."
  },
  payToCardMatchLevel: { id: 't.app.terminalsManagement.vasConfiguration.payToCard.matchLevel', defaultMessage: 'Match level' },
  payToCardExactMatch: { id: 't.app.terminalsManagement.vasConfiguration.payToCard.match.exact', defaultMessage: 'Exact match' },
  payToCardPartialMatch: { id: 't.app.terminalsManagement.vasConfiguration.payToCard.match.partial', defaultMessage: 'Partial match' },
  payToCardNoVerification: { id: 't.app.terminalsManagement.vasConfiguration.payToCard.match.none', defaultMessage: 'No verification' }
})

export default formattedMessage
